
  import React from "react"
  import Component from "M:/_AE/Maria2018/Website/src/layouts/index.js"
  import data from "M:\\_AE\\Maria2018\\Website\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js